import React, { useState, useEffect } from 'react';
import './JoueurInfo.css';
import { domain } from '../variables';
import axios from 'axios';

function JoueurInfo({player, championnat}) {
    const [performances, setPerformances] = useState([]);
    const [currentOnglet, setCurrentOnglet] = useState(1);
    const [currentPerformance, setCurrentPerformance] = useState(0);

    useEffect(() => {
        if (performances.length === 0) {
            getPerformancesPlayer()
        }
    }, []);

    const getPerformancesPlayer = async () => {
        const link = domain + '/server/getLivescoringResultats.php';
        await axios.post(
            link,
            {
                joueur: player.joueur,
            }
        ).then(res => {
            const data = res.data;
            if (res.data instanceof Array) {
                setPerformances(data);
            }
        })
    }

    const getBirthday = () => {
        const birthday = new Date(player.birthday).toLocaleDateString('fr-FR');
        if (birthday !== "Invalid Date") {
            return birthday;
        }
        return "";
    }

    const calculateAge = () => {
        var today = new Date();
        var birthDate = new Date(player.birthday);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age || 0;
    }

    const calculateWinrate = () => {
        let countVictory = 0;
        performances.forEach((match) => {
            if (isPlayerWinner(match)) {
                countVictory++;
            }
        })
        return (Math.floor((countVictory / performances.length) * 100)) || 0;
    }

    const isPlayerWinner = (match) => {
        if (match) {
            if (match.statut === "victoire_JA" && getPlayerA(match) === getCurrentPlayerName()) {
                return "winner";
            }
            if (match.statut === "victoire_JB" && getPlayerB(match) === getCurrentPlayerName()) {
                return "winner";
            }
        }
        return '';
    }

    const getPlayerA = (match) => {
        if (match) {
            return match.joueur_a.replace('  ', ' ').toUpperCase().trim();
        }
        return "empty_player_avatar";
    }

    const getPlayerB = (match) => {
        if (match) {
            return match.joueur_b.replace('  ', ' ').toUpperCase().trim();
        }
        return "empty_player_avatar";
    }

    const getCurrentPlayerName = () => {
        if (player) {
            return player.joueur.replace('  ', ' ').toUpperCase().trim();
        }
        return "empty_player_avatar";
    }

    const getCorrectOpponent = (match) => {
        if (match !== undefined) {
            if (getPlayerA(match) === getCurrentPlayerName()) {
                return getPlayerB(match);
            }
            return getPlayerA(match);
        }
        return "empty_player_avatar";
    }

    const getTeamOpponent = (match) => {
        if (getPlayerA(match) === getCurrentPlayerName()) {
            return match.club_2_name;
        }
        return match.club_1_name;
    }

    const getDateMatch = (match) => {
        let date = new Date(match.date).toLocaleString('fr-fr', {weekday: "long", year: "numeric", month: "long", day: "numeric"})
        return date.charAt(0).toUpperCase() + date.slice(1);
    }

    const handleNextMatch = (e, previousOrNext = 0) => {
        e.preventDefault();
        // 0 : previous / 1 : next
        // S'il reste des matchs à consulter
        // alors on passe au suivant
        if (previousOrNext === 1) {
            if (currentPerformance < (performances.length-1)) {
                setCurrentPerformance(currentPerformance + 1);
            }
        }
        else {
            if (currentPerformance > 0) {
                setCurrentPerformance(currentPerformance - 1);
            }
        }
    }

    const handleSetOnglet = (step) => {
        const newOnglet = currentOnglet + step;
        setCurrentOnglet(newOnglet);
        if (newOnglet === 2) {
            // on récupère les performances du joueur
            if (performances.length === 0) {
                getPerformancesPlayer()
            }
        }
    }

    const age = getBirthday() !== "" ? calculateAge() : null;
    const match = performances[currentPerformance];

    return (
        <article className={"joueur_card " + championnat}>
            {/* AVATAR DU JOUEUR */}
            <div className="joueur_card_photo">
                <img
                    className="player_picture"
                    src={process.env.PUBLIC_URL + "/images/players/" + getCurrentPlayerName() + ".png"}
                    alt={player.joueur}
                    loading="lazy"
                    onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.className = "empty_player_avatar";
                        currentTarget.src=process.env.PUBLIC_URL + "/images/players/empty_player_avatar.png";
                    }}
                />
            </div>
            {
                (currentOnglet === 1 &&
                // Informations du JOUEUR
                <div className="joueur_card_body">
                    <header className="joueur_card_header">
                        <h3 className="joueur_card_name">{player.joueur}</h3>
                        <img
                            className="joueur_info_flag"
                            src={process.env.PUBLIC_URL + "/images/atlas_flags/"+player.code_pays.toLowerCase()+"-flag.jpg"}
                            alt={player.nationalite || "drapeau"}
                            title={player.nationalite}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.className="flag_none"
                                currentTarget.src=process.env.PUBLIC_URL + "/images/atlas_flags/none.jpg";
                            }}
                        />
                    </header>

                    {/* Informations du joueur */}
                    <div className="joueur_card_meta">
                        {
                            age !== null &&
                            <span>{age} ans</span>
                        }
                        {
                            player.style &&
                            <span>{player.style}</span>
                        }
                    </div>

                    {/* Classements et victoires */}
                    <div className="joueur_card_stats">
                        <div className="joueur_card_stat">
                            <span className="joueur_card_stat_label">Class. mondial</span>
                            <span className="joueur_card_stat_value">
                                {(player.classement_mondial > 0 && "#" + player.classement_mondial) || "NC"}
                            </span>
                        </div>
                        <div className="joueur_card_stat">
                            <span className="joueur_card_stat_label">Class. français</span>
                            <span className="joueur_card_stat_value">#{player.classement}</span>
                        </div>
                        <div className="joueur_card_stat">
                            <span className="joueur_card_stat_label">Victoires</span>
                            <span className="joueur_card_stat_value">
                                {performances.length > 0 ? calculateWinrate() + "%" : "–"}
                            </span>
                        </div>
                    </div>

                    {/* Performances */}
                    <footer className="joueur_card_footer">
                        {
                            (performances.length > 0 &&
                            <button type="button" className="joueur_info_next" onClick={()=>handleSetOnglet(1)}>
                                Voir les performances ({performances.length}) <span aria-hidden="true">→</span>
                            </button>)
                            ||
                            <span className="joueur_info_nothing">Aucun match disputé</span>
                        }
                    </footer>
                </div>)
                || (currentOnglet === 2 &&
                <div className="joueur_card_body joueur_card_perf">
                    <header className="joueur_card_perf_header">
                        <button type="button" className="joueur_info_back" onClick={()=>handleSetOnglet(-1)}>
                            <span aria-hidden="true">←</span> Retour
                        </button>
                        <span className="joueur_card_perf_count">Match {currentPerformance + 1} / {performances.length}</span>
                    </header>
                    {/* Cette partie est réservée au résultat des matchs */}
                    {
                        match &&
                        <>
                            <div className="joueur_card_perf_title">
                                <span className={"joueur_card_badge " + (isPlayerWinner(match) ? "win" : "loss")}>
                                    {isPlayerWinner(match) ? "Victoire" : "Défaite"}
                                </span>
                                <span className="joueur_card_perf_opponent">
                                    VS {getCorrectOpponent(match)}
                                </span>
                            </div>
                            <div className="joueur_card_perf_meta">
                                {getDateMatch(match)} · {getTeamOpponent(match)}
                            </div>

                            {/* SETS SETS SETS ET MATCH */}
                            <div className="joueur_info_perf">
                                {
                                    match.total_points.split(';').map((item, index) => {
                                        return (
                                            <div key={index} className="joueur_info_scores">
                                                <span className={getCurrentPlayerName() === getPlayerA(match) ? "pj_scores_p" : ""}>{item.split(',')[0]}</span>
                                                <span className={getCurrentPlayerName() === getPlayerB(match) ? "pj_scores_p" : ""}>{item.split(',')[1]}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            {/* Bouton pour aller au match suivant */}
                            <div className="joueur_match_arrow">
                                <button
                                    type="button"
                                    className="pj_match_previous"
                                    disabled={currentPerformance === 0}
                                    onClick={(e)=>handleNextMatch(e)}
                                >
                                    ← Précédent
                                </button>
                                <button
                                    type="button"
                                    className="pj_match_next"
                                    disabled={currentPerformance >= performances.length - 1}
                                    onClick={(e)=>handleNextMatch(e, 1)}
                                >
                                    Suivant →
                                </button>
                            </div>
                        </>
                    }
                </div>)
            }

        </article>
    );
}

export default JoueurInfo;
